import React from "react";

export const InfoMovesContext = React.createContext();